import Phaser from 'phaser';
import { HAND_WHITE_TEXTURE, WOODEN_CLUB_TEXTURE } from './weapon-model';

export function queueWeaponLoad(scene: Phaser.Scene) {
  if (!scene.textures.exists(WOODEN_CLUB_TEXTURE)) {
    scene.load.image(WOODEN_CLUB_TEXTURE, 'WoodenClub.png');
  }
  if (!scene.textures.exists(HAND_WHITE_TEXTURE)) {
    scene.load.image(HAND_WHITE_TEXTURE, 'Hand_White.png');
  }
}

export async function prepareWeapon(scene: Phaser.Scene) {
  return scene.textures.exists(WOODEN_CLUB_TEXTURE) && scene.textures.exists(HAND_WHITE_TEXTURE);
}
